import {FC} from 'react'

import {IconSize} from '@/theme/icons'
import {theme} from '@/theme/theme'

import {Icon, IconProps} from './Icon'

export const PinIcon: FC<IconProps> = ({
  color = theme.palette.text.primary,
  size = IconSize.medium,
}) => (
  <>
    <Icon size={size}>
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M10.5 6.90549C11.7939 6.57246 12.75 5.39788 12.75 4C12.75 2.34315 11.4069 1 9.75 1C8.09314 1 6.75 2.34315 6.75 4C6.75 5.39788 7.70605 6.57246 9 6.90549V15.25C9 15.6642 9.33582 16 9.75 16C10.1642 16 10.5 15.6642 10.5 15.25V6.90549Z"
          fill={color}
        />
        <path
          d="M7.5 11.6743C6.40625 11.8325 5.41357 12.0929 4.58667 12.4351C3.87683 12.7288 3.25305 13.0976 2.79529 13.5455C2.33496 13.9959 2 14.572 2 15.2494C2 15.9268 2.33496 16.5029 2.79529 16.9532C3.25305 17.4011 3.87683 17.77 4.58667 18.0637C6.01001 18.6527 7.92432 18.9994 10 18.9994C12.0757 18.9994 13.99 18.6527 15.4133 18.0637C16.1232 17.77 16.7469 17.4011 17.2047 16.9532C17.665 16.5029 18 15.9268 18 15.2494C18 14.572 17.665 13.9959 17.2047 13.5455C16.7469 13.0976 16.1232 12.7288 15.4133 12.4351C14.462 12.0415 13.2915 11.756 12 11.61V13.1205C13.1031 13.2579 14.075 13.5046 14.8397 13.8211C15.4419 14.0702 15.8799 14.3478 16.1558 14.6178C16.4292 14.8853 16.5 15.0984 16.5 15.2494C16.5 15.4004 16.4292 15.6135 16.1558 15.881C15.8799 16.1509 15.4419 16.4286 14.8397 16.6777C13.639 17.1746 11.9283 17.4994 10 17.4994C8.07166 17.4994 6.36096 17.1746 5.16028 16.6777C4.55811 16.4286 4.12012 16.1509 3.84424 15.881C3.5708 15.6135 3.5 15.4004 3.5 15.2494C3.5 15.0984 3.5708 14.8853 3.84424 14.6178C4.12012 14.3478 4.55811 14.0702 5.16028 13.8211C5.80725 13.5533 6.60254 13.3355 7.5 13.1916V11.6743Z"
          fill={color}
        />
      </svg>
    </Icon>
  </>
)
